module.exports = __webpack_public_path__ + "static/img/bgCode1.b70f689c.jpg";